<template>
  <div class="content-expressions-content" id="identidade-verbal-conteudo-palavras-e-expressoes" data-search-anchor>
    <h1 class="content-expressions-title">
      {{ contentExpressionsTitle }}
    </h1>
    <div class="content-expressions-grid-wrapper">
       <div class="content-expressions-grid">
      <img class="content-expressions-image" :src="contentExpressionsCard1" />
      <img class="content-expressions-image" :src="contentExpressionsCard2" />
      <img class="content-expressions-image" :src="contentExpressionsCard3" />
      <img class="content-expressions-image" :src="contentExpressionsCard4" />
      <img class="content-expressions-image" :src="contentExpressionsCard5" />
      <img class="content-expressions-image" :src="contentExpressionsCard6" />
    </div>
    </div>
   
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import ContentPageMixin from '@/mixins/content-page-mixin'
import { ContentPageStore } from '@/store/verbal-identity-page/content-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class ContentExpressionsSection extends Mixins(ContentPageMixin) {
  contentPageStore: PageStoreContract = getModule(ContentPageStore, this.$store)

  get contentExpressionsTitle(): string {
    return this.getElementTitle(5, 0)
  }

  get contentExpressionsCard1(): string {
    return this.getElementMedia(5, 1)
  }

  get contentExpressionsCard2(): string {
    return this.getElementMedia(5, 2)
  }

  get contentExpressionsCard3(): string {
    return this.getElementMedia(5, 3)
  }

  get contentExpressionsCard4(): string {
    return this.getElementMedia(5, 4)
  }

  get contentExpressionsCard5(): string {
    return this.getElementMedia(5, 5)
  }

  get contentExpressionsCard6(): string {
    return this.getElementMedia(5, 6)
  }

  async getContentPage(): Promise<void> {
    await this.contentPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.contentPageStore.isLoading) {
      await this.getContentPage()
    }
  }
}
</script>


  <style lang="scss">

.content-expressions-title {
  font-size: 32px;
  font-weight: 400;
  line-height: 36px;
  text-align: left;
  margin-top: 148px;
  width: 100%;
}

.content-expressions-grid-wrapper {
  margin-top: 50px;
  margin-bottom: 47px;
}

.content-expressions-grid {
  column-count: 2;
  column-gap: 25px;
}

.content-expressions-grid > *:last-child {
  margin-bottom: 0;
}


.content-expressions-image {
  width: 100%;
  margin-bottom: 25px; 
  border-radius: 12px;
  display: block;
  break-inside: avoid;
}

</style>